var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.03125 0.05)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 32,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAYAAADskT9PAAACuUlEQVRIDZ1WS08TURT+vpmhj8ij7QCtBmONG4hBmriBYEK7Y2fduQDlJ+DOnbpSdCH/AKIJsKP+AksiMcSYFIkJG5Mu8IULaiTIAuaYO23J9HHh4k0mc88533e+k/smNC07NpUHOAFBBmC6CpMyiBI9Ft9uvHoTpN7NP8wSchtghpCMgBUAZUBKoFVYXn26FsTX+6x36v/s6FQWtF4SSljfRKQIyJNUagAEFkjUimzPEUFRgCcrhWfFIMIOGtnRe49JLhBIBf3t+iTTJGdsy+4JhTrG2mGCPlUgiZnhwfHK1vb6Rj12UkBVHI/qgbP+XZ3dcBMuQqGOobOwDXFycnjwFre23/kj4U+Bmm/CWm0AnscgkepL/qRlJU1pniCnpsNRBILzpkSF6+/rh2371CDNWLyqiQUAV5kdnZ5R8x7M9L/9/r7kZ9u2r5vyRbw7DsCsKUHh4rE4IpGojmIsXk1g5R21Z9UkmLa9yh4A9bW2Dsf+2NubvNka0XiItANyRBNu676YutTWX3Oai/trDxMtK+m07Cr2/ce3UyFnFNjCdSCyeZ5R0OyAlsQmDgHWHAFLBIynYffXrjZ3Z/TCeldPz7gW0BwQlB3QKwDW/eaYzo5GoojF4rqwubifwSv4yz83Nl0GeEWX1cQfCoW/uAn3mglWYQSyubw6l/EXoUBmCRofxeFwGIm426xlLO4XIJxVf/8yKu982k4PjJCE0aF0fHyM/f0//ndwcIBoOPLVsqzu5op0toj3YKUwt3JSgOqUdzaL6cs3fhOc1BGb/Wok3IR7aNt2ojmms5X4cuH5yd1jBYHF96/nRbwcRNq+XoJYhTk8/JsDrSG1nRpibQyFUTdgUFzBtGdw7WWUp6ijGrFazoqQJRwdLRY/LJWCOtUnmZcBrAzoc1T6CkRKhLe4VHjRgK9z/wG8E8B2D/LWjAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.515cfb031bad31733647bff7acf2f58f.svg";
export { ForwardRef as ReactComponent };